let practice_account_reminder = function( $ ) {

	let $remind_later_link;

	let _init = function() {
		$remind_later_link = $( '#remind-practice-setup-later' );

		if ( $remind_later_link.length > 0 ) {
			_setup_trigger();
		}
	};

	let _setup_trigger = function() {
		$remind_later_link.on( 'click', function( e ) {
			e.preventDefault();

			let redirect_after = $remind_later_link.attr( 'href' ) !== '#' ? $remind_later_link.attr( 'href' ): '';

			_remind_later( redirect_after );
		} );
	};

	let _remind_later = function( redirect_after ) {

		let data = {
			action: 'crate_postpone_practice_setup_reminder',
			nonce: ScriptData.crate_postpone_practice_setup_reminder,
		};

		$.post( ScriptData.ajaxurl, data, function( response ) {
			if ( redirect_after ) {
				window.location.href = redirect_after
			} else {
				window.location.reload();
			}
		} );
	};

	$( document ).ready( _init );

} (jQuery);

module.exports = practice_account_reminder;